// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b31dcb6e","455":"3d84f5f2","977":"260ada8b"}[chunkId] + ".chunk.js";
};